import { InvoiceInterface } from 'constants/invoice';
import React, { createContext, useCallback, useContext, useState } from 'react';

interface InvoiceContextData {
  invoice: InvoiceInterface | undefined;
  setInvoiceData(data: InvoiceInterface | undefined): void;
}

const InvoiceContext = createContext<InvoiceContextData>(
  {} as InvoiceContextData
);

const InvoiceProvider: React.FC = ({ children }) => {
  const [invoice, setInvoice] = useState<InvoiceInterface | undefined>();

  const setInvoiceData = useCallback(
    (data: InvoiceInterface | undefined) => {
      setInvoice(data);
    },
    [setInvoice]
  );

  return (
    <InvoiceContext.Provider value={{ invoice, setInvoiceData }}>
      {children}
    </InvoiceContext.Provider>
  );
};

function useInvoice(): InvoiceContextData {
  const context = useContext(InvoiceContext);

  if (!context) {
    throw new Error('useInvoice must be used within a InvoiceProvider');
  }

  return context;
}

export { InvoiceProvider, useInvoice };
